// extracted by mini-css-extract-plugin
module.exports = {"successWrapper":"src-components-messages-Success-styles__successWrapper","success":"src-components-messages-Success-styles__success"};